import z from "zod";

export const reasonSchema = z.object({
  value: z.string().trim().min(8, 'Tamanho mínimo: 8 caracteres'),
  file: z.custom<File>().optional(),
});

export type ReasonValidationSchema = z.infer<typeof reasonSchema>;
